var map = {
	"./home1.jpg": 7897,
	"./home2.jpg": 7630,
	"./home3.jpg": 5675,
	"./home4.jpg": 2584,
	"./home6.jpg": 1178,
	"./home7.jpg": 2567,
	"./home8.jpg": 484,
	"./home9.jpg": 2289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7195;